module.exports = __webpack_public_path__ + "img/cooler-master-tshirt-preview.feb52b0a.png";